import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight, faCheck} from '@fortawesome/free-solid-svg-icons'
import logoImage from '../img/consultMidiaLogo.png';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {useHistory} from "react-router-dom";
import React from "react";
import FacebookPixel from "../capturePixel/Facebook";

import TagManager from 'react-gtm-module'

export function SecondQuestion() {
    const tagManagerArgs = {
        gtmId: 'GTM-P88PQ8P'
    }

    TagManager.initialize(tagManagerArgs)

    const history = useHistory();

    const MySwal = withReactContent(Swal);

    function handleQuestion() {
        const email = document.getElementById("email") as HTMLInputElement;

        if (validateEmail(email.value)) {
            sessionStorage.setItem('email', email.value);
            history.push('/third');
        } else {
            MySwal.fire({
                icon: 'error',
                title: '',
                text: "Email Inválido",
                position: 'top',
                showConfirmButton: false,
                timer: 1500,
            })
        }
    }

    function validateEmail(email: string) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }


    function clickButton(event: React.KeyboardEvent<HTMLInputElement>) {
        const buttonSubmit = document.getElementById("buttonSubmit") as HTMLInputElement;

        if (event.key === "Enter") {
            buttonSubmit.click();
        }
    }

    return (
        <>
            <FacebookPixel nameTracking="Second"/>
            <div className="progress">
                <div className="progress-bar progress-bar-40" role="progressbar"/>
            </div>
            <div className="container">
                <div className=" d-block d-md-none">
                    <img className="img-fluid image" src={logoImage} alt="logo"/>
                </div>
                <section className="container-body">
                    <div className="row d-flex flex-column align-content-lg-start">
                        <div className="col-lg-2">
                            <span>2<FontAwesomeIcon icon={faArrowRight}/></span>
                        </div>
                        <div className="col-lg-10 align-self-end mr-5">
                            <span className="span">Legal, e qual é o seu e-mail? </span>
                            <div className="py-2 pr-4">
                                <input autoFocus className="input" id="email" onKeyDown={clickButton}
                                       placeholder="alguem@exemplo.com"/>
                            </div>

                        </div>
                    </div>
                    <div className="row d-flex">
                        <div className="col-sm-2 d-block">
                            <button id="buttonSubmit" onClick={handleQuestion} type="submit">Próximo<FontAwesomeIcon
                                icon={faCheck}/>
                            </button>
                        </div>
                        <div className="col-sm-10 confirmation">
                            Pressione <strong>Enter ↵</strong>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}